import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";

export default function SectionHeading({ overline, title, linkTo, linkLabel }) {
  return (
    <div className="flex items-end justify-between gap-8 mb-10 sm:mb-14">
      <div>
        {overline && (
          <Reveal>
            <p className="jm-overline mb-4">{overline}</p>
          </Reveal>
        )}
        <Reveal delay={0.08}>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-jm-bone leading-[1.1] max-w-2xl">{title}</h2>
        </Reveal>
      </div>
      {linkTo && (
        <Reveal delay={0.15} className="shrink-0 hidden sm:block">
          <Link
            to={linkTo}
            data-testid={`section-link-${linkTo.replace(/\//g, "")}`}
            className="inline-flex items-center gap-2 text-sm text-jm-brass hover:text-jm-amber transition-colors duration-300 tracking-wide"
          >
            {linkLabel}
            <ArrowUpRight size={15} />
          </Link>
        </Reveal>
      )}
    </div>
  );
}
